module.exports = __webpack_public_path__ + "img/featured-vehicle-row-23-kia.a4ccbeb1.jpg";